export default __webpack_public_path__ + "images/08fcfaa29102028b2fc63e00ab61cbf0.svg";